import { createContentPropTypes } from '../../helpers/content';

const content = {
	heading: 'Exchange rate',
	description: 'Get the live exchange rate before you authorise your payment.',
	title: 'Live rate:',
	refresh: 'Refresh',
	buttonText: 'Get rate',
	expiredRateText: 'This exchange rate has expired. Please refresh to fetch a new exchange rate.',
	rateCounterText: 'This rate will expire in :counter seconds',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
